<app-view #view [code]="'transactionsTypes.edit'" [model]="transactionType" (onEvent)="onEvent($event)"></app-view>